var render = function render(){var _vm=this,_c=_vm._self._c;return _c('cropper',{ref:"cropper",staticClass:"crop-box",attrs:{"src":_vm.image,"stencil-props":{
    handlers: {},
  },"stencil-size":{
    width: 500,
    height: 500,
  },"image-restriction":"stencil","background-class":"cropper-background"}})
}
var staticRenderFns = []

export { render, staticRenderFns }